var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("custom-btn-icon", {
    attrs: {
      "btn-text": _vm.paused ? "Relâcher" : "Libérer",
      loading: _vm.loading,
      disabled: _vm.loading,
      color: "error",
      icon: _vm.paused ? "mdi-play" : "mdi-account-cancel"
    },
    on: { click: _vm.onClick }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }